(function() {
  'use strict';

  function initLpTinkerSection(section) {
    if (!section?.dataset.productId || !section?.dataset.sectionId) return;

    const sectionId = section.dataset.sectionId;
    let mainSwiper = null, thumbSwiper = null;
    const selectedOptions = {};

    // Initialize Swiper sliders
    function initSwipers() {
      const mainSliderEl = section.querySelector('.lp-tinker__main-slider');
      const thumbSliderEl = section.querySelector(`.lp-tinker__thumb-slider-${sectionId}`);

      // Thumb slider params
      if (thumbSliderEl && !thumbSwiper) {
        thumbSwiper = new Swiper(thumbSliderEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true
        });
      }

      // Main slider params
      if (mainSliderEl && !mainSwiper) {
        mainSwiper = new Swiper(mainSliderEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            prevEl: section.querySelector(`.lp-tinker__nav-prev-${sectionId}`),
            nextEl: section.querySelector(`.lp-tinker__nav-next-${sectionId}`)
          },
          on: {
            init: function() {
              // Setup thumbnail clicks after main slider is fully initialized
              setTimeout(() => setupThumbnailClicks(mainSliderEl), 50);
            }
          }
          // Don't use Swiper's built-in thumbs to handle clicks manually
        });
        
        // Fallback: Setup thumbnail clicks if on.init doesn't fire
        if (mainSwiper.initialized) {
          setTimeout(() => setupThumbnailClicks(mainSliderEl), 100);
        }
      }
    }

    function setupThumbnailClicks(mainSliderEl) {
      const thumbSliderEl = section.querySelector(`.lp-tinker__thumb-slider-${sectionId}`);
      if (!thumbSliderEl || !mainSwiper) return;

      // Use event delegation on the thumb slider wrapper - more reliable
      const wrapper = thumbSliderEl.closest('.lp-tinker__thumb-slider-wrapper');
      if (!wrapper) return;

      // Remove existing handler if re-initializing
      if (wrapper.dataset.clickHandlerAttached) {
        const existingHandler = wrapper._clickHandler;
        if (existingHandler) {
          wrapper.removeEventListener('click', existingHandler, true);
        }
      }
      
      // Create new handler
      const clickHandler = function(e) {
        // Find the thumb slide - could be clicked on the slide itself or the image inside
        let thumbSlide = e.target.closest('.lp-tinker__thumb-slide');
        
        // If clicked on image, find parent slide
        if (!thumbSlide && e.target.closest('.lp-tinker__thumb')) {
          thumbSlide = e.target.closest('.lp-tinker__thumb').parentElement;
        }
        
        if (!thumbSlide || !mainSwiper) return;

        e.preventDefault();
        e.stopPropagation();

        const slideIndex = parseInt(thumbSlide.dataset.index);
        if (!isNaN(slideIndex) && slideIndex >= 0) {
          // Get all main slides (including hidden ones)
          const allSlides = section.querySelectorAll('.lp-tinker__media-slide');
          
          // Find the actual slide element by index
          if (allSlides[slideIndex]) {
            // Check if slide is hidden
            const targetSlide = allSlides[slideIndex];
            if (targetSlide.classList.contains('hidden')) {
              // If hidden, show it first
              targetSlide.classList.remove('hidden');
              mainSwiper.update();
            }
            
            // Navigate to the slide
            mainSwiper.slideTo(slideIndex, 300);
          }
        }
      };
      
      // Store handler reference and attach
      wrapper._clickHandler = clickHandler;
      wrapper.dataset.clickHandlerAttached = 'true';
      wrapper.addEventListener('click', clickHandler, true);
    }

    // Variant selection
    function updateVariant() {
      try {
        const variants = JSON.parse(section.dataset.productVariants || '[]');
        let variant = null;
        
        // Find variant matching all selected options
        variant = variants.find(v => {
          // Get all option selectors from the page
          const optionSelectors = section.querySelectorAll('[data-option-name]');
          let allOptionsMatch = true;
          
          optionSelectors.forEach(selector => {
            const optionName = selector.dataset.optionName;
            const selectedValue = selectedOptions[optionName];
            
            if (selectedValue) {
              // Match by option position (1, 2, or 3)
              const position = parseInt(selector.closest('[data-option-position]')?.dataset.optionPosition) || 1;
              let variantOptionValue = '';
              
              if (position === 1) variantOptionValue = v.option1;
              else if (position === 2) variantOptionValue = v.option2;
              else if (position === 3) variantOptionValue = v.option3;
              
              if (variantOptionValue !== selectedValue) {
                allOptionsMatch = false;
              }
            }
          });
          
          return allOptionsMatch;
        });
        
        if (variant) {
          updateMediaForVariant(variant);
          updatePrice(variant);
          section.querySelector('.lp-tinker__add-to-cart')?.setAttribute('data-variant-id', variant.id);
        }
      } catch (e) {
        console.error('Error parsing variants:', e);
      }
    }

    function updateMediaForVariant(variant) {
      if (!variant) return;
      
      const slides = section.querySelectorAll('.lp-tinker__media-slide');
      const thumbs = section.querySelectorAll('.lp-tinker__thumb-slide');
      const variantId = variant.id.toString();
      
      // Get variant's featured media ID
      const variantMediaId = variant.featured_image?.id || variant.featured_media?.id || variant.featured_media_id;
      const variantMediaIdStr = variantMediaId ? variantMediaId.toString() : null;
      
      // Get product featured image ID (first media) as fallback
      const firstSlide = slides[0];
      const featuredMediaId = firstSlide ? firstSlide.dataset.mediaId : null;
      
      // Determine which media ID to show
      const targetMediaId = variantMediaIdStr || featuredMediaId;
      
      let targetSlideIndex = 0;
      let hasVisibleSlides = false;

      // Show/hide slides based on variant
      slides.forEach((slide, index) => {
        const slideMediaId = slide.dataset.mediaId;
        const productImages = slide.dataset.productImages?.split(',').filter(Boolean) || [];
        
        // If variant has no featured media, show only featured image (first slide)
        if (!variantMediaIdStr) {
          const isFeatured = index === 0;
          slide.classList.toggle('hidden', !isFeatured);
          if (isFeatured) {
            targetSlideIndex = parseInt(slide.dataset.index) || 0;
          }
        } else {
          // Show if:
          // 1. Media ID matches variant's featured media
          // 2. Variant ID is in product images for this slide
          const shouldShow = slideMediaId === variantMediaIdStr || productImages.includes(variantId);
          slide.classList.toggle('hidden', !shouldShow);
          
          if (shouldShow && !hasVisibleSlides) {
            hasVisibleSlides = true;
            targetSlideIndex = parseInt(slide.dataset.index) || index;
          }
        }
      });

      // Update thumbnails
      thumbs.forEach(thumb => {
        const thumbMediaId = thumb.dataset.mediaId;
        const isActive = targetMediaId && thumbMediaId === targetMediaId;
        thumb.classList.toggle('lp-tinker__thumb-slide--active', isActive);
        if (isActive && thumbSwiper) {
          thumbSwiper.slideTo(parseInt(thumb.dataset.index));
        }
      });

      // Update main slider to show target slide
      if (mainSwiper) {
        mainSwiper.update();
        setTimeout(() => {
          if (!isNaN(targetSlideIndex)) {
            mainSwiper.slideTo(targetSlideIndex, 300);
          }
        }, 100);
      }
    }

    function updatePrice(variant) {
      const priceEl = section.querySelector('.lp-tinker__button-price');
      if (priceEl && variant.price) {
        priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
      }
    }

    // Event handlers - variant buttons
    section.querySelectorAll('.lp-tinker__variant-button').forEach(btn => {
      btn.addEventListener('click', function() {
        const optionName = this.closest('[data-option-name]').dataset.optionName;
        const optionValue = this.dataset.optionValue || this.dataset.scentValue || this.dataset.sizeValue;
        const listbox = this.closest('[role="listbox"]');

        listbox.querySelectorAll('[role="option"]').forEach(opt => {
          opt.classList.remove('lp-tinker__variant-button--active', 'lp-tinker__scent-button--active', 'lp-tinker__size-button--active');
          opt.setAttribute('aria-selected', 'false');
        });
        this.classList.add('lp-tinker__variant-button--active');
        if (this.classList.contains('lp-tinker__scent-button')) {
          this.classList.add('lp-tinker__scent-button--active');
        }
        if (this.classList.contains('lp-tinker__size-button')) {
          this.classList.add('lp-tinker__size-button--active');
        }
        this.setAttribute('aria-selected', 'true');

        selectedOptions[optionName] = optionValue;
        updateVariant();
      });
    });

    section.querySelector('.lp-tinker__add-to-cart')?.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = Number(this.dataset.variantId);
      if (!variantId) return;

      this.setAttribute('disabled', 'disabled');
      this.style.opacity = '0.7';

      document.dispatchEvent(new CustomEvent('addToCartCustom', { detail: { id: variantId, qty: 1 } }));

      setTimeout(() => {
        this.removeAttribute('disabled');
        this.style.opacity = '1';
      }, 1200);
    });

    // Initialize selected options
    section.querySelectorAll('.lp-tinker__variant-button--active').forEach(btn => {
      const optionName = btn.closest('[data-option-name]').dataset.optionName;
      selectedOptions[optionName] = btn.dataset.optionValue || btn.dataset.scentValue || btn.dataset.sizeValue;
    });
    
    // Fallback to Core Scent/Size if variant selector not used
    const firstScent = section.querySelector('.lp-tinker__scent-button');
    const firstSize = section.querySelector('.lp-tinker__size-button');
    if (firstScent && !selectedOptions['Core Scent']) selectedOptions['Core Scent'] = firstScent.dataset.scentValue;
    if (firstSize && !selectedOptions['Size']) selectedOptions['Size'] = firstSize.dataset.sizeValue;

    // Initialize Swiper first, then update variant to show correct media
    if (typeof Swiper !== 'undefined') {
      initSwipers();
      // Update variant after Swiper is initialized to show correct media
      setTimeout(() => updateVariant(), 200);
    } else {
      window.addEventListener('load', () => {
        if (typeof Swiper !== 'undefined') {
          initSwipers();
          setTimeout(() => updateVariant(), 200);
        }
      });
    }
  }

  // Initialize sections
  const initSections = () => {
    document.querySelectorAll('.lp-tinker[data-section-id]').forEach(initLpTinkerSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.detail.querySelector('.lp-tinker');
    if (section) initLpTinkerSection(section);
  });
})();
